<template>
  <div class="wrap">

    <Head />
    <div class="part1">
      <p class="tit">区块链证券交易平台</p>
      <p class="txt">基于联盟链搭建资产证券化过程中各参与方之间的连接，将区块链技术应用于资产证券化各环节，打造形成公开透明的资产证券化市场</p>
      <div class="img">
        <img
          src="../../../assets/images/mobile/solution/part1-1.png"
          alt=""
        >
      </div>
    </div>

    <div class="part2">
      <p class="tit">方案介绍</p>
      <div
        class="show"
        id="show"
        style="height:auto"
      >
        <div class="line">
          本方案利用联盟链搭建资产证券化过程中各参与方之间的连接，将区块链技术应用于资产证券化全过程的六个阶段落地中。基于区块链技术特性将资产信息上链，保障数据公开、真实、不可篡改。链上的产品设计全流程透明化，建立全新的信任机制，将大幅度优化资产证券化流程。
        </div>
        <div class="line">
          恒为区块链资产证券化平台通过区块链技术实现对录入系统的资产池数据、现金流预算结果、风险评级更加精确的资产洞察、现金流管理、数据分析和投后管理。平台将评级公司和券商确认的交易结构和评级结果进行共识上链，完成产品发行。并将回款数据、循环购买数据、资产赎回数据、置换和回购数据上链，生成资产服务报告，实现存续期管理。投资方可从链上获取资产池、现金流等信息数据，同时也可以进行相关数据上链。
        </div>
      </div>
      <div
        class="btn"
        v-show="show"
      >
        <div class="btn">
          <p
            @click="getChange('more')"
            v-show="more"
          >
            <span>查看更多</span>
            <i class="iconfont  iconxia"></i>
          </p>
          <p
            @click="getChange('less')"
            v-show="!more"
          >
            <span>收起</span>
            <i class="iconfont  iconshang"></i>
          </p>
        </div>
      </div>
      <div class="img">
        <img
          src="../../../assets/images/mobile/solution/asset/part2.png"
          alt=""
        >
      </div>

    </div>

    <div class="part3">
      <p class="tit">方案价值</p>
      <div class="center">
        <div class="card">
          <div class="left">
            <img
              src="../../../assets/images/mobile/solution/asset/part3-1.png"
              alt=""
            >
          </div>
          <div class="right">
            <p class="title">投资方受益</p>
            <p class="text">
              利用区块链实现穿透式监控底层资产，可全程监控资产历史信息、实时表现等
            </p>
          </div>
        </div>

        <div class="card">
          <div class="left">
            <img
              src="../../../assets/images/mobile/solution/asset/part3-2.png"
              alt=""
            >
          </div>
          <div class="right">
            <p class="title">资产发行方受益</p>
            <p class="text">
              灵活透明的产品设计、信息验证渠道实时响应，有效提升投资者信心，降低操作及合规成本
            </p>
          </div>
        </div>

        <div class="card">
          <div class="left">
            <img
              src="../../../assets/images/mobile/solution/asset/part3-3.png"
              alt=""
            >
          </div>
          <div class="right">
            <p class="title">资产管理方受益</p>
            <p class="text">
              通过区块链技术实现资产生成、筛选组包、资产分析、产品设计、展示上架、投资兑付、资产监控等全流程智能化管理
            </p>
          </div>
        </div>
      </div>

    </div>


   


    <Foot />
  </div>
</template>
<script>
import Head from "../../../components/mobile/Head.vue";
import Foot from "../../../components/mobile/Foot.vue";
export default {
  data() {
    return {
      show: false,
      more: true,
    };
  },
  components: {
    Head,
    Foot,
  },
  created() {},
  mounted() {
    this.getShow();
  },
  methods: {
    //判断是否显示加载更多
    getShow() {
      let h = document.getElementById("show").offsetHeight;
      let w = document.body.clientWidth;
      if (h > w * 0.31) {
        this.show = true;
        document.getElementById("show").style.height = "31vw";
      } else {
        this.show = false;
      }
    },
    getChange(type) {
      if (type == "more") {
        this.more = false;
        document.getElementById("show").style.height = "auto";
      } else {
        this.more = true;
        document.getElementById("show").style.height = "31vw";
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/css/mixin';

.wrap {
}

.part1 {
  height: vw(650);

  background: linear-gradient(-30deg, #019EDF, #1CC8E7);
  position: relative;
  part1();
  padding-top: vw(57);

  .tit {
    margin-bottom: vw(22);
    hTit();
  }

  .txt {
    font-size: vw(24);
    line-height: vw(36);
    text-align: center;
    color: #fff;
    padding: 0 vw(80);
  }

  .img {
    width: 100%;
    position: absolute;
    bottom: vw(20);
    text-align: center;

    img {
      width: vw(440);
      height: vw(351);
    }
  }
}

.part2 {
  part();
  background: #fff;

  .tit {
    tit3();
    margin-bottom: vw(30);
  }

  .show {
    overflow: hidden;
    transition: all 0.3s ease;

    .line {
      font-size: vw(28);
      color: #666666;
      line-height: vw(48);
      margin-bottom: vw(30);
      padding: 0 vw(30);
    }
  }

  .btn {
    margin-top: vw(40);

    p {
      width: vw(240);
      height: vw(80);
      background: #fff;
      border-radius: vw(40);
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
      text-align: center;
      margin: 0 auto;

      span {
        display: inline-block;
        height: vw(80);
        color: #2A93FF;
        font-size: vw(30);
        line-height: vw(80);
      }

      i {
        margin-left: vw(5);
        display: inline-block;
        height: vw(80);
        font-size: vw(24);
        color: #2A93FF;
        line-height: vw(80);
      }
    }
  }

  .img {
    margin-top: vw(60);
    text-align: center;

    img {
      width: vw(690);
      height: auto;
    }
  }
}

.part3 {
  part();
  background: rgba(249, 249, 249, 1);

  .tit {
    tit3();
    margin-bottom: vw(30);
  }

  .center {
    width: 100%;

    .card {
      display: flex;
      width: vw(690);
      height: vw(241);
      margin: 0 auto vw(30);
      padding: vw(44) vw(45) 0 vw(40);
      background: #fff;
      box-shadow: 0px 0px vw(10) 0px rgba(0, 0, 0, 0.1);

      .left {
        width: vw(179);
        margin-right: vw(37);
        padding-top: vw(14);

        img {
          width: 100%;
          height: auto;
        }
      }

      .right {
        flex: 1;

        .title {
          font-size: vw(32);
          line-height: vw(32);
          margin: vw(4) 0 vw(10);
          color: #444444;
        }

        .text {
          font-size: vw(24);
          color: #888;
          line-height: vw(36);
          showline(3)
        }
      }
    }
  }
}

.part4 {
  part();
  background: #fff;
  padding: vw(80) 0 vw(40);

  .tit {
    tit3();
    margin-bottom: vw(80);
  }

  .card {
    width: vw(690);
    padding: vw(20);
    margin: 0 auto vw(40);
    background: #fff;
    box-shadow: 0px 0px vw(10) 0px rgba(0, 0, 0, 0.1);

    .img {
      text-align: center;

      img {
        width: vw(650);
        height: auto;
      }
    }

    .content {
      margin-top: vw(60);

      .title {
        font-size: vw(32);
        font-weight: 500;
        color: rgba(68, 68, 68, 1);
        line-height: vw(32);
        margin-bottom: vw(30);
        text-align: center;
      }

      .line {
        font-size: vw(24);
        color: #888888;
        line-height: vw(36);
        margin-bottom: vw(40);
      }
    }
  }
}
</style>
